"use strict";
// (C) 2007-2021 GoodData Corporation
Object.defineProperty(exports, "__esModule", { value: true });
exports.ViewByAttributesLimit = void 0;
var limits_1 = require("./limits");
Object.defineProperty(exports, "ViewByAttributesLimit", { enumerable: true, get: function () { return limits_1.ViewByAttributesLimit; } });
//# sourceMappingURL=index.js.map